export default `import crypto from 'crypto';

const APIKey = 'YOUR_API_KEY';

export default function generateCannyHash(user) {
  const hash = crypto.createHmac('sha256', APIKey)
    .update(user.id)
    .digest('hex');
  return hash;
}`;
